import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
//import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import { ToastContainer } from 'react-toastify';

import { loadMessages, locale } from 'devextreme/localization';
import ruMessages from 'devextreme/localization/messages/ru.json';

import App from './App';
import { store } from './bus/configureStore';
import Login from './components/layout/container/auth';
import { AuthProvider, IAuth, useAuth } from './context/auth';
import reportWebVitals from './reportWebVitals';

function Container() {
  useEffect(() => {
    loadMessages(ruMessages);
    locale(navigator.language);
  }, []);

  const { isAuth, loading }: IAuth = useAuth();

  if (loading) {
    return <div>Загрузка...</div>;
  }

  if (isAuth) {
    return <App />;
  }

  return <Login />;
}

render(
  <Provider store={store}>
    <BrowserRouter>
      <AuthProvider>
        <Container />
      </AuthProvider>
    </BrowserRouter>
    <ToastContainer />
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
